import { _ } from "@icc/shared/helpers";

export interface ComplaintNote {
    /**
     * Numer porządkowy
     */
    id?: number;

    /**
     * Unikalny numer w formacie UUID v4
     */
    uuid: string;

    /**
     * Uuid dokumentu
     */
    documentId: string;

    /**
     * Uuid pozycji (usterki)
     */
    positionId?: string | null;

    /**
     * Czas utworzenia notatki
     */
    created?: Date;

    /**
     * Czas modyfikacji notatki
     */
    modified?: Date;

    /**
     * Czas utworzenia notatki na serwerze
     */
    createdServer?: Date;

    /**
     * Czas modyfikacji notatki na serwerze
     */
    modifiedServer?: Date;

    /**
     * Identyfikator klienta (przeglądarki), w którym powstała notatka
     */
    machineId?: string;

    /**
     * Treść notatki
     */
    content: string;

    /**
     * Widoczność notatki
     */
    visibility: 'private' | 'public' | 'internal' | 'manufacturerDistributor';

    /**
     * Identyfikator firmy autora notatki
     */
    authorCompanyId?: number;

    /**
     * Identyfikator użytkownika autora notatki
     */
    authorUserId?: number;

    /**
     * Uuid notatki, na którą odpowiada notatka
     */
    replyId?: string;

    /**
     * Identyfikator wiadomości e-mail (IMAP UID lub Graph API message ID),
     * z której powstała notatka
     */
    emailMessageUid?: string;

    /**
     * Czy oczekuje na zapis
     */
    $dirty?: boolean;
}

export type ComplaintNoteDTO = Omit<
    ComplaintNote,
    'createdServer' | '$dirty'
>;

export const ComplaintNoteNonReadableProps = [
    'id',
    'uuid',
    'documentId',
    'positionId',
    'created',
    'modified',
    'createdServer',
    'modifiedServer',
    'machineId',
    'replyId',
    '$dirty',
] as const satisfies readonly (keyof ComplaintNote)[];

export const ComplaintNoteReadableProps: Record<Exclude<keyof ComplaintNote, typeof ComplaintNoteNonReadableProps[number]>, string> = {
    content: _('COMPLAINT|Treść notatki'),
    visibility: _('COMPLAINT|Widoczność notatki'),
    authorCompanyId: _('COMPLAINT|Identyfikator firmy autora notatki'),
    authorUserId: _('COMPLAINT|Identyfikator użytkownika autora notatki'),
    emailMessageUid: _('COMPLAINT|Identyfikator wiadomości email'),
}
